import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { SupplierOrderResource } from "@exonn/js-sdk";

export const module: Module<SupplierOrderResource> = {
  id: ResourceEnum.SupplierOrder,
  bigIcon: <i className="icon-20-selling" />,
  smallIcon: <i className="icon-15-selling" />,
  name: (t: TFunction) => t("moduleName.supplier-orders"),

  disableDelete: true,
  disableEdit: true,
  disableCreate: true,

  tabs: {
    edit: {
      getTitle: (row) => row.order_number,
    },
  },
};
